import { getProductCollectionsJson } from '../sections/product-page/helpers';

/**
 * Breadcrumbs component
 * 
 * This class is responsible for handling the breadcrumbs on the product page.
 * It initializes the breadcrumbs based on the top product collection.
 */
export default class Breadcrumbs {
  elements;
  topLevelCollections;
  
  constructor() {
    this.topLevelCollections = [
      'dresses',
      'tops',
      'sweaters',
      'bottoms',
      'jackets-outerwear',
    ];

    this.elements = {
      breadcrumbsContainers: document.querySelectorAll('.breadcrumbs'),
      breadcrumbsDynamic: document.querySelectorAll('.breadcrumbs__dynamic'),
    };

    if (this.elements.breadcrumbsContainers.length > 0 && this.elements.breadcrumbsDynamic.length > 0) {
      // const previous_collection = this.retrievePreviousCollection();
      // console.log('previous_collection', previous_collection);

      // Dispatch a custom event to use the same extracted data for product seo
      // let collection_data = {
      //   title: 'Shop All',
      //   handle: 'shop-all',
      // };

      // if (typeof previous_collection !== 'undefined') {
      //   collection_data = {
      //     title: previous_collection.title,
      //     handle: previous_collection.handle,
      //   };
      // }

      // const event = new CustomEvent('astr-previous-collection', { 
      //   detail: {
      //     message: 'Previous collection found for breadcrumbs',
      //     data: collection_data,
      //   }
      // });

      // document.dispatchEvent(event);

      this.addTopLevelCollectionToBreadcrumbs();
    }
  }

  retrieveTopLevelCollection = () => {
    try {
      // Validate product collections JSON
      const product_collections_json = getProductCollectionsJson();
      if (!Array.isArray(product_collections_json)) {
        console.warn('[Breadcrumbs] Invalid product collections JSON.');
        return;
      }

      const top_level_collection = product_collections_json.find((collection) => this.topLevelCollections.includes(collection.handle));

      if (typeof top_level_collection === 'undefined') {
        console.warn('[Breadcrumbs] Top level collection not found.');
        return;
      }

      return top_level_collection;
    } catch (error) {
      console.error('[Breadcrumbs] Error in retrieveTopLevelCollection function:', error);
    }
  };

  addTopLevelCollectionToBreadcrumbs = () => {
    try {
      const top_level_collection = this.retrieveTopLevelCollection();
      if (typeof top_level_collection === 'undefined') {
        console.warn('[Breadcrumbs] Top level collection not found.');
        return;
      }

      Array.from(this.elements.breadcrumbsContainers).forEach((breadcrumbsContainer) => {
        const top_level = breadcrumbsContainer.querySelector('.breadcrumbs__top-level');

        if (!top_level) {
          return;
        }

        top_level.innerHTML = `<a href="${window.Shopify.routes.root}collections/${top_level_collection.handle}">${top_level_collection.title}</a>`;
        breadcrumbsContainer.querySelector('.breadcrumbs__dynamic').classList.remove('visually-hidden');
      });
    } catch (error) {
      console.error('[Breadcrumbs] Error in addTopLevelCollectionToBreadcrumbs function:', error);
    }
  };

  /*
  retrievePreviousCollection = () => {
    try {
      // Validate product collections JSON
      const product_collections_json = getProductCollectionsJson();
      if (!Array.isArray(product_collections_json)) {
        console.warn('[Breadcrumbs] Invalid product collections JSON.');
        return;
      }

      // Validate referrer
      if (!document.referrer || !document.referrer.includes('/collections/')) {
        console.warn('[Breadcrumbs] Referrer does not contain a collection.');
        return;
      }

      let previous_collection_handle = '';
      let previous_collection_title = '';

      // window.localStorage.getItem('previous-page')
      const previous_collection_parts = document.referrer.split('/');

      // ["https:", "", "www.astrthelabel.com", ("en-gb"), "collections", "whats-new", ("red")]
      if (previous_collection_parts.length < 5) {
        return;
      }

      previous_collection_handle = previous_collection_parts[previous_collection_parts.indexOf('collections') + 1].split('?')[0];

      const previous_collection = product_collections_json.find((collection) => collection.handle === previous_collection_handle);

      if (typeof previous_collection === 'undefined') {
        return;
      }

      previous_collection_title = previous_collection.title;
      
      Array.from(this.elements.breadcrumbsContainers).forEach((breadcrumbsContainer) => {
        const previous = breadcrumbsContainer.querySelector('.breadcrumbs__previous');

        if (!previous) {
          return;
        }

        if (previous_collection_title.toLowerCase() === 'shop all') {
          previous.remove();

          return {
            title: previous_collection_title,
            handle: previous_collection_handle,
          };
        }
      
        if (!breadcrumbsContainer || previous.innerHTML !== '') {
          return;
        }

        previous.innerHTML = `<a href="${document.referrer}">${previous_collection_title}</a>`;
        breadcrumbsContainer.querySelector('.breadcrumbs__dynamic').classList.remove('visually-hidden');
      });

      return {
        title: previous_collection_title,
        handle: previous_collection_handle,
      };
    } catch (error) {
      console.error('[Breadcrumbs] Error in init function:', error);
    }
  };
  */
}
